(() => {
  function init(root) {
    if (!root || root.dataset.bnAdInitialized === 'true') return;
    root.dataset.bnAdInitialized = 'true';
    const article = root.querySelector('.bn-ad__article');
    const readTime = root.querySelector('[data-bn-ad-read-time]');
    if (article && readTime) {
      const words = article.innerText.trim().split(/\s+/).length;
      readTime.textContent = `${Math.max(1, Math.ceil(words / 230))} min read`;
    }
  }
  const initAll = () => document.querySelectorAll('[data-bn-advertorial]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bn-advertorial]').forEach(init));
})();
